var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowTopRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-top-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.85767 22.3913C5.03199 22.3924 5.20478 22.3589 5.36601 22.2926C5.52724 22.2263 5.67367 22.1286 5.7968 22.0052L19.6751 8.11653V17.3931C19.6805 17.7375 19.8189 18.0665 20.0611 18.3113C20.1816 18.434 20.3253 18.5315 20.4839 18.5981C20.6424 18.6646 20.8127 18.6989 20.9846 18.6989C21.1566 18.6989 21.3268 18.6646 21.4854 18.5981C21.644 18.5315 21.7877 18.434 21.9081 18.3113C22.1475 18.0654 22.2822 17.7362 22.2838 17.3931L22.3046 4.93392C22.3016 4.75744 22.2626 4.58344 22.1898 4.42262C22.1283 4.26418 22.032 4.12156 21.9081 4.00523C21.7899 3.88356 21.6478 3.78764 21.4907 3.72349C21.3302 3.64989 21.156 3.61079 20.9794 3.6087H8.52028H8.41593C8.15618 3.6091 7.90237 3.68642 7.68652 3.83092C7.47067 3.97541 7.30246 4.18061 7.20311 4.42061C7.10376 4.66061 7.07773 4.92466 7.12829 5.17944C7.17886 5.43422 7.30376 5.66831 7.48724 5.85218C7.60843 5.97527 7.75304 6.07284 7.91254 6.13915C8.07204 6.20546 8.2432 6.23916 8.41593 6.23827H17.8072L3.90811 20.1165C3.78471 20.2397 3.68703 20.3861 3.62074 20.5473C3.55446 20.7085 3.5209 20.8813 3.52202 21.0557C3.5192 21.2318 3.55182 21.4068 3.61795 21.5701C3.68407 21.7334 3.78235 21.8818 3.90694 22.0064C4.03153 22.131 4.1799 22.2293 4.34322 22.2954C4.50655 22.3615 4.68149 22.3941 4.85767 22.3913Z",
    fill: "#24963F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTopRight);
export default __webpack_public_path__ + "static/media/arrow-top-right.e5fed0d64047b61dda62fb9f770812c0.svg";
export { ForwardRef as ReactComponent };